import clsx from 'clsx';
import { useEffect, useState } from 'react';
import { FormStatusEnum } from '../../types/enums/form-status.enum';
import { getStatusStyle, getStatusValue } from '../../utils/statusHelpers';

interface StatusValues {
  status: FormStatusEnum | string;
  isStatusBorderNeeded?: boolean;
}

function Status({ status, isStatusBorderNeeded = true }: StatusValues) {
  const [statusStyle, setStatusStyle] = useState<any>(null);
  const [statusValue, setStatusValue] = useState<any>(null);

  useEffect(() => {
    setStatusStyle(getStatusStyle(status));
    setStatusValue(getStatusValue(status));
  }, [status]);

  return (
    <div className="row d-flex justify-content-between status-container col-12 col-md-11 position-relative">
      <p className="col-3 status-label">ESTADO</p>
      <p className={clsx('col-sm-3 col-md-3 py-2 px-3 status-value', statusStyle)}>{statusValue}</p>
      {isStatusBorderNeeded && <span className="status-border" />}
    </div>
  );
}

export default Status;
